import { render, staticRenderFns } from "./TournamentTeams.vue?vue&type=template&id=02e068e4&"
import script from "./TournamentTeams.vue?vue&type=script&lang=js&"
export * from "./TournamentTeams.vue?vue&type=script&lang=js&"
import style0 from "./TournamentTeams.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TournamentTeams.vue"
export default component.exports